import { useContext } from "react";

import { useHistory, useParams } from "react-router-dom";

import { ViewerContext } from "@/tpo/Viewer";

import Template from "../shared/Template";
import { REPORTS_LIST_QUERY } from "./graphql/queries";
import ReportsGrid from "@/components/customerView/reports/reportList/ReportGrid";

function WardReportsContent() {
  const history = useHistory();
  const { patientId } = useParams();
  const { userId } = useContext(ViewerContext);

  return (
    <ReportsGrid
      query={REPORTS_LIST_QUERY}
      queryVariables={{
        userId
      }}
      onReportClick={userReport =>
        history.push(`/patients/${patientId}/reports/${userReport.slug}/overview`)
      }
    />
  );
}

export default function WardReports() {
  return (
    <Template selectedTab="reports" docTitle="Reports">
      <WardReportsContent />
    </Template>
  );
}
